module.exports = __webpack_public_path__ + "static/media/tornquist.5b79c0d6.webp";